/*===================================================================
=     SPENDING DEMAND PAGE            =
====================================================================*/
/**
 * Spending 
 */
import React from 'react'
import './spendingDemandListPage.scss';
import SpendingDemandList from '../../../features/spendingDemand/components/SpendingDemandList';
import { useSpendingDemand } from '../../../features/spendingDemand/hooks';
import { SpendingDemandManagerPresenterFilter } from '../../../features/spendingDemand/components/SpendingDemandList/SpendingDemandListFilter/SpendingDemandManagerPresenterFilter';
import ExtractButtonV2 from '../../../features/spendingDemand/components/SpendingDemandList/ExtractButton/ExtractButtonV2';
import PageLayout from '../../../components/organismes/PageLayout/PageLayout';

const  SpendingDemandPage = () => {
  const { spendingDemandSelected } = useSpendingDemand();
  
  // Vérifier s'il y a des éléments sélectionnés
  const hasSelectedItems = spendingDemandSelected && spendingDemandSelected.length > 0;

  return (
    <PageLayout 
      title="Demande de dépenses"
      maxWidth="1300px"
      titleClassName="page--title"
    >
      {/* Section d'extraction */}
      <div style={{ width: "100%", marginBottom: "10px" }}>
        <ExtractButtonV2 />
      </div>
      
      <div style={{width: "100%"}}> 
        <SpendingDemandManagerPresenterFilter/>
      </div>

      <div style={{
        display: 'flex', 
        gap: hasSelectedItems ? '20px' : '0px', 
        marginTop: '20px',
        transition: 'gap 0.3s ease-in-out'
      }}>
        {/* Zone principale avec la liste */}
        <div style={{
          flex: 1,
          transition: 'width 0.3s ease-in-out'
        }}>
          <SpendingDemandList.ListManager withSelectMode linkBase='/spending_demand'/>
        </div>
        
        {/* Volet à droite pour les actions groupées - affiché seulement si des éléments sont sélectionnés */}
        {hasSelectedItems && (
          <div 
            className="actions-panel"
            style={{
              width: '350px', 
              minHeight: '200px'
            }}
          >
            <SpendingDemandList.GroupedActionBtn />
          </div>
        )}
      </div>
    </PageLayout>
  )
}

export default SpendingDemandPage
